import { DATETIME_FORMAT } from 'constants/date'
import moment from 'moment'
import _range from 'lodash/range'

export const roundUpDateMoment = (period = 5): moment.Moment => {
  const momentTime = moment(
    moment().utcOffset('+09:00').format(DATETIME_FORMAT.standardFullDateTimeFormat),
  )
  const minutes = momentTime.minute()
  momentTime.add((period - (minutes % period)) % period, 'minutes')
  momentTime.seconds(0).milliseconds(0)
  return momentTime
}

export const formatTimeUnit = (value: string, unit: 'HH' | 'mm') => {
  const units: { [key: string]: string } = {
    HH: '時',
    mm: '分',
  }
  return `${value}${units[unit]}`
}
